function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#fff;stroke-width:0.7px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.35 0.48)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M14.806,47.634a.4.4,0,0,0-.4.4v3.547a1.2,1.2,0,0,1-1.2,1.2H2a1.2,1.2,0,0,1-1.2-1.2V41.17a1.2,1.2,0,0,1,1.2-1.2H5.545a.4.4,0,1,0,0-.8H2a2,2,0,0,0-2,2V51.581a2,2,0,0,0,2,2H13.208a2,2,0,0,0,2-2V48.034A.4.4,0,0,0,14.806,47.634Zm0,0",
  transform: "translate(0 -37.617)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M118.915.787a1.8,1.8,0,0,0-2.543,0l-7.128,7.128a.4.4,0,0,0-.1.176l-.937,3.384a.4.4,0,0,0,.492.492l3.384-.938a.4.4,0,0,0,.176-.1L119.384,3.8a1.8,1.8,0,0,0,0-2.543Zm-8.8,7.388,5.834-5.834,1.881,1.881L112,10.056Zm-.376.754,1.5,1.5-2.079.576Zm9.08-5.7-.424.424-1.882-1.882.424-.424a1,1,0,0,1,1.412,0l.469.469A1,1,0,0,1,118.819,3.234Zm0,0",
  transform: "translate(-103.867 -0.261)"
}));

var SvgEditWhite = function SvgEditWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.872,
    height: 16.792,
    viewBox: "0 0 16.872 16.792",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/editWhite.9d6bec7f.svg";
export { ForwardRef as ReactComponent };